import IconAbandoned from 'assets/images/finalScreen/IconAbandoned.png';
import IconCancel from 'assets/images/finalScreen/IconCancel.png';
import IconError from 'assets/images/finalScreen/IconError.png';
import IconExpired from 'assets/images/finalScreen/IconExpired.png';
import IconFail from 'assets/images/finalScreen/IconFail.png';
import IconFinalPending from 'assets/images/finalScreen/IconFinalPending.png';
import IconPending from 'assets/images/finalScreen/IconPending.png';
import IconNotPermitted from 'assets/images/finalScreen/IconNotPermitted.svg';
import IconSuccess1 from 'assets/images/finalScreen/IconSuccess1.png';
import IconSuccess2 from 'assets/images/finalScreen/IconSuccess2.png';
import IconSuccess3 from 'assets/images/finalScreen/IconSuccess3.png';
import IconSuccess4 from 'assets/images/finalScreen/IconSuccess4.png';
import IconSuccess5 from 'assets/images/finalScreen/IconSuccess5.png';
import IconSuccess6 from 'assets/images/finalScreen/IconSuccess6.png';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PROGRESS = {
  NOT_SELECTED_PAYMENT_METHOD: 0,
  BLIK_CLICK_FIELD: 37.5,
  BLIK_CODE_VERIFICATION: 75,
  BLIK_FILL_3_NUMBERS: 50,
  BLIK_FILL_6_NUMBERS: 62.5,
  BLIK_REDIRECT: 75,
  CARD_BM_PAYMENT_TOKEN_FAILURE: 0,
  CARD_BM_PAYMENT_TOKEN_PENDING: 50,
  CARD_BM_PAYMENT_TOKEN_SUCCESS: 75,
  CARD_WORLDLINE_PAYMENT_FIELDS_VALIDATION: 50,
  CARD_WORLDLINE_PAYMENT_TOKEN_PENDING: 52.5,
  CARD_WORLDLINE_PAYMENT_TOKEN_SUCCESS: 75,
  PAYMENT_FAILURE: 0,
  PAYMENT_PENDING: 85,
  PAYMENT_SUCCESS: 100,
  SELECT_BLIK_METHOD: 25,
  SELECT_CARD_METHOD: 25,
  SELECT_GPAY_METHOD: 75,
  SELECT_C2P_METHOD: 75,
  SELECT_APPLE_PAY_METHOD: 75,
  SELECT_PBL_BANK: 75,
  SELECT_PAYPO_METHOD: 75,
  SELECT_PBL_METHOD: 25,
  UNSELECT_GPAY_METHOD: 25,
  UNSELECT_APPLE_PAY_METHOD: 25,
  UNSELECT_PAYPO_METHOD: 25,
};
const APP_STATUS = {
  ABANDONED: 'ABANDONED',
  ERROR: 'ERROR',
  EXISTS: 'EXISTS',
  EXPIRED: 'EXPIRED',
  FAILURE: 'REJECTED',
  FINAL_PENDING: 'FINAL_PENDING',
  NEW: 'NEW',
  PENDING: 'PENDING',
  SUCCESS: 'CONFIRMED',
  WAITING_FOR_SUCCESS: 'WAITING_FOR_CONFIRMATION',
};

const CONFLICT = 'CONFLICT';
const REDIRECT_TIME = 8000;
const BLIK_COUNTDOWN_TIME = 60000;
const DEFAULT_COUNTDOWN_TIME = 6000;
const FAST_COMPLETE = 4500;
const COUNTDOWN_REQUEST_LOOP_TIME = 1000;
const REDIRECT_TO_STATUS = 1000;

const SUCCESS_SCREENS = [
  {
    buttonText: 'backToShop',
    description: 'finalScreenSuccess.description',
    icon: IconSuccess1,
    message: 'finalScreenSuccess.message1',
    title: 'finalScreenSuccess.title1',
  },
  {
    buttonText: 'backToShop',
    description: 'finalScreenSuccess.description',
    icon: IconSuccess2,
    message: 'finalScreenSuccess.message2',
    title: 'finalScreenSuccess.title1',
  },
  {
    buttonText: 'backToShop',
    description: 'finalScreenSuccess.description',
    icon: IconSuccess3,
    message: 'finalScreenSuccess.message3',
    title: 'finalScreenSuccess.title1',
  },
  {
    buttonText: 'backToShop',
    description: 'finalScreenSuccess.description',
    icon: IconSuccess4,
    message: 'finalScreenSuccess.message4',
    title: 'finalScreenSuccess.title1',
  },
  {
    buttonText: 'backToShop',
    description: 'finalScreenSuccess.description',
    icon: IconSuccess5,
    message: 'finalScreenSuccess.message1',
    title: 'finalScreenSuccess.title1',
  },
  {
    buttonText: 'backToShop',
    description: 'finalScreenSuccess.description',
    icon: IconSuccess6,
    message: 'finalScreenSuccess.message2',
    title: 'finalScreenSuccess.title1',
  },
];

const FAILURE_SCREENS = [
  {
    buttonText: 'backToShop',
    icon: IconFail,
    message: 'finalScreenFailure.message',
    title: 'finalScreenFailure.title',
  },
];

const FAILURE_ERROR_SCREENS = {
  buttonText: 'backToShop',
  icon: IconFail,
  message1: 'finalScreenFailureError.message1',
  message2: 'finalScreenFailureError.message2',
  title: 'finalScreenFailureError.title',
};

const FAILURE_REJECT_SCREENS = {
  buttonText: 'backToShop',
  icon: IconFail,
  message1: 'finalScreenFailureReject.message1',
  message2: 'finalScreenFailureReject.message2',
  title: 'finalScreenFailureReject.title',
};

const PAYMENT_INIT_FAIL_SCREEN_LEVEL_HALF = {
  buttonText: 'backToShop',
  icon: IconFail,
  messageTitle: 'finalScreenInitPaymentFail.messageTitle',
  messageContent: 'finalScreenInitPaymentFail.messageContent',
  pageTitle: 'finalScreenInitPaymentFail.pageTitle',
};

const PAYMENT_INIT_FAIL_SCREEN_LEVEL_ONE = {
  buttonText: 'backToPaywall',
  icon: IconFail,
  messageTitle: 'finalScreenInitPaymentFail.messageTitle',
  messageContent: 'finalScreenInitPaymentFail.messageContent',
  pageTitle: 'finalScreenInitPaymentFail.pageTitle',
};

const CANCEL_SCREEN = {
  description: 'finalScreenCancel.description',
  icon: IconCancel,
  status: 'finalScreenCancel.status',
  statusText: 'finalScreenCancel.statusText',
};

const EXPIRED_SCREEN = {
  description: 'finalScreenExpired.description',
  icon: IconExpired,
  status: 'finalScreenExpired.status',
  statusText: 'finalScreenExpired.statusText',
};

const TOKEN_EXPIRED_SCREEN = {
  description: 'finalScreenTokenExpired.description',
  contact: 'finalScreenTokenExpired.contact',
  icon: IconExpired,
  statusText: 'finalScreenTokenExpired.statusText',
};

const ABANDONED_SCREEN = {
  backToShopButtonText: 'backToShop',
  description: 'finalScreenAbandoned.description',
  goToRecoveredPaymentButtonText: 'goToRecoveredPayment',
  icon: IconAbandoned,
  status: 'finalScreenAbandoned.status',
  statusText: 'finalScreenAbandoned.statusText',
};

const NOT_PERMITTED_SCREEN = {
  description: 'finalScreenNotPermitted.description',
  icon: IconNotPermitted,
  statusText: 'finalScreenNotPermitted.statusText',
};

const ERROR_SCREEN_TYPES = {
  AUTHORIZATION: 'AUTHORIZATION',
  DEFAULT: 'DEFAULT',
  PAYMENT: 'PAYMENT',
  PAYMENT_TOKEN_EXPIRED: 'PAYMENT_TOKEN_EXPIRED',
  STATUS_TOKEN_EXPIRED: 'STATUS_TOKEN_EXPIRED',
  NOT_PERMITTED: 'NOT_PERMITTED',
};

const ERROR_VIEW = {
  AUTHORIZATION: {
    description: 'finalScreenError.authorization.description',
    status: 'finalScreenError.authorization.status',
    statusText: 'finalScreenError.authorization.statusText',
  },
  DEFAULT: {
    description: 'finalScreenError.default.description',
    status: 'finalScreenError.default.status',
    statusText: 'finalScreenError.default.statusText',
  },
  ICON: IconError,
  PAYMENT: {
    description: 'finalScreenError.payment.description',
    status: 'finalScreenError.payment.status',
    statusText: 'finalScreenError.payment.statusText',
  },
  STATUS_TOKEN_EXPIRED: {
    description: 'finalScreenError.statusTokenExpired.description',
    status: 'finalScreenError.statusTokenExpired.status',
    statusText: 'finalScreenError.statusTokenExpired.statusText',
  },
};

const PENDING_SCREEN = {
  buttonText: 'pay.text',
  description: 'finalScreenPending.description',
  icon: IconPending,
  status: 'finalScreenPending.status',
  statusText: 'finalScreenPending.statusText',
};

const UNREALIZED_SCREEN = {
  description: 'finalScreenUnrealized.description',
  icon: IconFail,
  status: 'finalScreenUnrealized.status',
  statusText: 'finalScreenUnrealized.statusText',
};

const FINAL_PENDING_SCREEN = {
  buttonText: 'backToShop',
  icon: IconFinalPending,
  status: 'finalPendingScreen.status',
  statusText: 'finalPendingScreen.statusText',
};

const REALISED_SCREEN = {
  description: 'realisedScreen.description',
  icon: IconSuccess3,
  status: 'transaction.status',
  statusText: 'status.realised',
};

const IN_PROGRESS_SCREEN = {
  buttonText: 'finalScreenInProgress.buttonText',
  description: 'finalScreenInProgress.description',
  icon: IconPending,
  retryMessage: 'finalScreenInProgress.retryMessage',
  status: 'transaction.status',
  statusText: 'finalScreenInProgress.status',
};

const STARTED_SCREEN = {
  buttonText: 'startedStatusScreen.buttonText',
  retryMessage: 'startedStatusScreen.retryMessage',
};

const BM_WIDGET_LOCALE = {
  en: 'en',
  pl: 'pl',
  uk: 'uk',
};

enum SelectPaymentMethodChangeStatus {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  CAN_BE_CHANGED = 'CAN_BE_CHANGED',
  CHANGED = 'CHANGED',
}

enum AppState {
  PAYMENT = 'PAYMENT',
  STATUS = 'STATUS',
  CALLBACK = 'CALLBACK',
  INIT_FIELD = 'INIT_FIELD',
  ERROR = 'ERROR',
}

export {
  AppState,
  ABANDONED_SCREEN,
  BASE_URL,
  PROGRESS,
  CANCEL_SCREEN,
  CONFLICT,
  EXPIRED_SCREEN,
  TOKEN_EXPIRED_SCREEN,
  NOT_PERMITTED_SCREEN,
  SUCCESS_SCREENS,
  FAILURE_SCREENS,
  FAILURE_ERROR_SCREENS,
  FAILURE_REJECT_SCREENS,
  PAYMENT_INIT_FAIL_SCREEN_LEVEL_HALF,
  PAYMENT_INIT_FAIL_SCREEN_LEVEL_ONE,
  UNREALIZED_SCREEN,
  PENDING_SCREEN,
  FAST_COMPLETE,
  REDIRECT_TIME,
  REALISED_SCREEN,
  ERROR_VIEW,
  APP_STATUS,
  BLIK_COUNTDOWN_TIME,
  DEFAULT_COUNTDOWN_TIME,
  COUNTDOWN_REQUEST_LOOP_TIME,
  FINAL_PENDING_SCREEN,
  REDIRECT_TO_STATUS,
  IN_PROGRESS_SCREEN,
  ERROR_SCREEN_TYPES,
  STARTED_SCREEN,
  BM_WIDGET_LOCALE,
  SelectPaymentMethodChangeStatus,
};
